'use client'

import _ from 'lodash'
import { useEffect, useState } from 'react'
import { redirect } from 'next/navigation'
import AppleSignin from 'react-apple-signin-auth'
import { Button } from '@/components'
import { authApi } from '@/api'
import { useGlobalStore } from '@/store/provider'
import { appleClientId } from '@/settings'
import { webBaseUrl, pages } from '@/settings'
import { Auth } from '@/types/auth'

// https://github.com/a-tokyo/react-apple-signin-auth#readme

export function SignInWithApple({ afterSignIn }: Auth.SignInProps) {
  const { user, setUser } = useGlobalStore((state) => state)
  const [isWorking, setIsWorking] = useState(false)
  const [token, setToken] = useState<string>('')

  async function signIn() {
    setIsWorking(true)
    try {
      const d = await authApi.signInWithApple({ token, client_id: appleClientId })
      setUser(d.data, null)
    } catch {
      setIsWorking(false)
    }
  }

  useEffect(() => {
    if (_.isEmpty(user) || !isWorking) return
    setIsWorking(false)
    if (afterSignIn) {
      afterSignIn()
    } else {
      // Default action if no afterSignIn function is provided
      redirect(pages.myProfile.href)
    }
  }, [user?._id])


  useEffect(() => {
    if (!_.isEmpty(token)) {
      signIn()
    }
  }, [token])

  return (
    <AppleSignin
      authOptions={{
        clientId: appleClientId,
        scope: 'email name',
        usePopup: true,
        redirectURI: webBaseUrl
      }}
      uiType='light'
      onSuccess={(response: any) => setToken(response?.authorization?.id_token)}
      onError={() => { }}
      render={(props: any) =>
        <Button type='button' variant='outline' className='btn-signin' {...props} working={isWorking}>
          <img src='/img/apple-logo-128.png' className='w-5 mr-3 dark:hidden' />
          <img src='/img/apple-logo-128-reverse.png' className='w-5 mr-3 hidden dark:inline-block' />
          Sign in with Apple
        </Button>
      }
    />

  )
}